import { render } from "./PageList.vue?vue&type=template&id=60e04a16"
import script from "./PageList.vue?vue&type=script&setup=true&lang=js"
export * from "./PageList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/PageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60e04a16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60e04a16', __exports__)) {
    api.reload('60e04a16', __exports__)
  }
  
  module.hot.accept("./PageList.vue?vue&type=template&id=60e04a16", () => {
    api.rerender('60e04a16', render)
  })

}


export default __exports__